const KEY_CODES = {
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  LEFT: 37,
  TAB: 9,
  ENTER: 13,
  DELETE: 8
};
export default KEY_CODES;